<ng-container *transloco="let t">
  <form [formRoot]="creationForm" class="flex h-full min-h-0 flex-col">
    <div class="scrollbar flex min-h-0 flex-1 flex-col gap-6 px-px pb-4">
      <IFormField class="shrink-0">
        <label iLabel>{{ t("common.name") }}</label>
        <input iInput [formField]="creationForm.name" size="sm" />
      </IFormField>
      <div class="flex min-h-100 flex-1 flex-col gap-2 overflow-hidden">
        <label iLabel class="shrink-0">{{ t("common.product") }}</label>
        <p class="text-muted-foreground type-label shrink-0">
          {{ t("dsp-custom-creative-creation.product_description") }}
        </p>
        @if (creationForm.asin().errors().length > 0 && creationForm.asin().touched()) {
          <span class="text-destructive type-label shrink-0">{{ t(creationForm.asin().errors()[0].message!) }}</span>
        }
        <app-asin-selection
          class="min-h-0 flex-1 overflow-hidden"
          ineligibilityTag="SP"
          [customList]="customProductList"
          [asinsLimit]="1"
          [readonly]="modalData.isReadOnly"
          [withBulk]="true"
          [selectedAsins]="selectedAsins()"
          (selectedAsinsChange)="selectedAsinsChanged($event)"
        />
      </div>
      <div class="flex shrink-0 flex-col gap-2">
        <label iLabel>{{ t("sb-form-assets.title") }}</label>
        @if (creationForm.assets().errors().length > 0 && creationForm.assets().touched()) {
          <span class="text-destructive type-label">{{ t(creationForm.assets().errors()[0].message!) }}</span>
        }
        <div class="flex items-center justify-between">
          <div>
            <span class="type-label text-muted-foreground">{{
              t("dsp-custom-creative-creation.amazon_size_requirement")
            }}</span>
            <div class="flex flex-wrap gap-2">
              @for (size of recommendedImageSizes; track size) {
                <span class="type-label">{{ size.label }}</span>
              }
            </div>
          </div>

          <button iButton variant="secondary" size="sm" [disabled]="!canAddAsset()" (click)="openMediaSelectionModal()">
            <IIcon name="plus" />
            {{ t("dsp-custom-creative-creation.add_image") }}
          </button>
        </div>

        <div class="flex items-start gap-4">
          @for (asset of creationForm.assets().value(); track asset) {
            <div class="group relative flex items-center justify-center rounded-lg border">
              <img [src]="asset.url" [alt]="asset.name" class="size-24 object-contain" />
              <div class="type-label absolute bottom-0 left-0 w-full rounded-b-lg bg-white/90 p-1">
                {{ asset.width }}x{{ asset.height }}
              </div>
              <div
                class="absolute top-0 left-0 flex w-full justify-end gap-1.5 rounded-t-lg p-1 opacity-0 transition-opacity duration-150 group-hover:opacity-100"
              >
                <button iButton variant="secondary" size="icon-sm" (click)="expandAsset(asset)">
                  <IIcon name="expand" />
                </button>
                <button iButton variant="secondary" size="icon-sm" (click)="removeAsset(asset.assetId)">
                  <IIcon name="trash" />
                </button>
              </div>
            </div>
          } @empty {
            <div
              class="text-muted-foreground flex w-full items-center justify-center rounded-lg border border-dashed py-8"
            >
              {{ t("dsp-custom-creative-creation.no_assets_added_yet") }}
            </div>
          }
        </div>
      </div>
    </div>
    <div class="flex shrink-0 justify-between gap-2 border-t pt-4">
      <button iButton variant="secondary" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
      <div class="flex items-center gap-2">
        @if (uploadingAsset()) {
          <span class="type-label text-muted-foreground">{{
            t("dsp-custom-creative-creation.uploading_asset_hint")
          }}</span>
        }
        <button iButton type="submit" [loading]="formSubmitting() || uploadingAsset()">
          {{ uploadingAsset() ? t("dsp-custom-creative-creation.uploading_asset") : t("common.create") }}
        </button>
      </div>
    </div>
  </form>
</ng-container>
